export default __webpack_public_path__ + "static/media/AustinScharosch.11b22d16.jpg";